import { Link } from "react-router-dom";

// import preview from "../../assets/images/preview.png";
import FeatureCarousel from "../About/components/FeatureCarousel";
import { featureCardData } from "../About/data/featureCardData";
import UnlockingIntelligence from "../About/components/UnlockingIntelligence";

// css
import styles from "./Landing.module.css";

// icons
import { Zap, MoveRight, Play } from "lucide-react";

function Home() {
  return (
    <>
      <div className={`${styles.home}`}>
        <div className={`${styles.homeContainer} container text-center`}>
          <h1 className={`${styles.headingXl}`} style={{ paddingTop: "10%" }}>
            <span className={styles.gradientText}>
              Unlock Hidden Value <br /> in Every Page
            </span>
          </h1>

          <p className="mt-4 text-white">
            Data Revival is a unique AI end-to-end data structuring and
            retrieval system for chemical archives, giving you unprecedented,
            contextual access to all your complex data sources.
          </p>
          <div className="mt-4">
            <Link
              to="/signup"
              className={`${styles.primaryButton} btn px-3 py-2 me-3`}
            >
              <div className="d-flex justify-content-center">
                Get Started <MoveRight className="ms-2" />
              </div>
            </Link>
            <Link
              to="/registration"
              className={`${styles.secondaryButton} btn px-3 py-2`}
            >
              <div className="d-flex justify-content-center">
                Watch Demo <Play className="ms-2" />
              </div>
            </Link>
          </div>
        </div>

        {/* analytics */}
        <section
          className="py-5 mt-5"
          style={{ backgroundColor: "#101828" }}
          id="why"
        >
          <div className={`${styles.sectionContainer} container mb-5`}>
            <div className="row row-cols-1 row-cols-md-3 g-4">
              <div className="col">
                <div className={`${styles.cardHow} card h-100 text-white`}>
                  <div className="card-body">
                    <h5 className="card-title">Unlock hidden data</h5>
                    <p className="card-text">
                      Vast volumes of valuable scientific data lie dormant in
                      legacy systems, spreadsheets, and lab notebooks. Our
                      mission is to bring that data back to life.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className={`${styles.cardHow} card h-100 text-white`}>
                  <div className="card-body">
                    <h5 className="card-title">Revive and unify</h5>
                    <p className="card-text">
                      We’ve built a breakthrough suite of tools to revive and
                      unify your chemical data, from physical archives to
                      digital repositories, from numbers to molecules.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className={`${styles.cardHow} card h-100 text-white`}>
                  <div className="card-body">
                    <h5 className="card-title">Discover the undiscovered</h5>
                    <p className="card-text">
                      Our chemical informatics platform creates smart,
                      relational links between datasets, enabling deep semantic
                      searches across millions of records to uncover insights.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* numbers */}
        <section className="py-5" style={{ backgroundColor: "#50c5d7" }}>
          <div className={`${styles.sectionContainer} container text-white`}>
            <div className="row">
              <div className="col-sm mt-3 mb-3">
                <div className="text-center">
                  <h4 className={`${styles.numbersHeaders}`}>Spoofing works</h4>
                  Fake emails look real and slip past filters
                </div>
              </div>
              <div className="col-sm mt-3 mb-3">
                <div className="text-center">
                  <h4 className={`${styles.numbersHeaders}`}>
                    Weak settings leak
                  </h4>
                  Setup errors let scammers use real names
                </div>
              </div>
              <div className="col-sm mt-3 mb-3">
                <div className="text-center">
                  <h4 className={`${styles.numbersHeaders}`}>Static fails</h4>
                  Old defenses miss new phishing tricks
                </div>
              </div>
              <div className="col-sm mt-3 mb-3">
                <div className="text-center">
                  <h4 className={`${styles.numbersHeaders}`}>Trust at risk</h4>
                  One wrong click can cost you everything
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* how it works  */}
        <section id="how">
          <div className={`${styles.sectionContainer} container`}>
            <div
              className={`${styles.howContainer} container text-center w-75`}
              style={{ marginTop: "8%" }}
            >
              <h2 className={`${styles.sectionHeaders} text-white`}>
                How We Revive Information's Potential
              </h2>
            </div>

            <div>
              <FeatureCarousel featureCards={featureCardData} />
            </div>
          </div>
        </section>

        <section>
          <div
            className={`${styles.sectionContainer} container text-center pb-5`}
          >
            <div
              className="p-5 text-white rounded mt-5"
              style={{ backgroundColor: "#1e2939" }}
            >
              <div className="mb-3 d-inline-block">
                <Zap size={40} style={{ color: "#00a6f4" }} />
              </div>
              <h3 className={`${styles.sectionHeaders} mt-3 mb-3`}>
                Amplify Your Data. Accelerate Your Research.
              </h3>
              <p>
                Stop sifting, start researching. Data Revival provides the
                AI-powered lens to bring clarity and structure to your vast
                swathes of locked data. We empower you to harness the full
                potential of your chemical data, efficiently and effectively.
              </p>
              <Link
                to="/registration"
                className={`${styles.primaryButton} btn px-3 py-2 mt-3`}
              >
                Learn How Data Revival Can Help You
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
